<template>
	<div class="jointActivitywarp">
		<NavMenu/>
		<div class="containerBox">
			<div class="content_warp">
				<div class="titleBox">面试考官培训项目</div>
				<div class="p">各类组织在招聘、选拔人才过程中，需要组织面试工作，在面试过程中需要大量的考官提供专业的服务。目前，没有专职从事面试考官的人员，多为兼职。为提升面试考官的能力水平，培养建立专业的面试考官人才队伍，助力各类组织选人用人，实现高质量发展，中国人才交流协会联合地方社会组织等机构，合作开展面试考官培训项目。</div>
				<div class="p">培训内容：面试的概念、目的、分类、历史沿革和技术理论基础；相关制度和政策；面试内容、方法、程序及测评方案设计；面试考官的职责定位和职业素养要求；人才测评的基本理论知识和技术；面试的组织与实施；面试的技法及评价要领、实操模拟等。</div>
				<div class="p">适用人群：
					<div class="p">★人力资源服务机构中兼职承担各类面试考官工作的人员，包括人力资源招聘主管、专员以及资深顾问等。</div>
					<div class="p">★各级政府部门、事业单位中从事组织人事工作，且需参与面试考官工作的科级及以上干部，以及负责招聘工作的具体办事人员。​</div>
					<div class="p">★各类企业的中高层管理者，在企业自主开展的人才选拔或参与行业相关考务面试时承担面试考官职责的人员。​</div>
					<div class="p">★企业人力资源部门全体人员，包括人力资源总监、经理、主管及专员，无论是否已实际参与面试工作，均可通过培训提升专业能力，为后续承担面试考官工作做准备。​</div>
					<div class="p">★教育、医疗、金融、制造等不同行业领域内，负责内部人才选拔、职称评定工作并担任面试考官的专业技术人员和管理人员。</div>
					<div class="p">★高校、科研机构等单位中，参与研究生、博士生招收面试、科研项目团队成员选拔等面试考官工作的教师、科研人员及行政管理人员。​</div>
					<div class="p">★有意向从事面试考官工作，且具备一定人力资源管理知识或相关行业经验的社会人士，如职业规划师、职业指导师、企业培训师等，期望通过培训进入该领域或提升自身竞争力。</div>
				</div>
				<div class="p">培训证书：
					<div class="p">培训结束经考核合格后，由中国人才交流协会与合作单位联合颁发结业证书，同时，电子证书可在中国人才交流协会官网面试考官库中查询。面试考官培训证书有效期两年，到期可通过线上进行继续教育学习予以延期。有效期内，协会将积极推荐学员参加各种兼职面试考官工作。</div>
					<div class="p">项目合作联系人：阎娜  13801323768</div>	
				</div>
				<!-- <div class="seconedBox">
					<div class="titleBox">首批实施项目</div>
					<div class="databox">
						<div v-for="(item,i) in seconedData" :key="i" class="Itembox">
							<div class="num">0{{i+1}}</div>
							<div class="text">
								{{item.text}}
							</div>
						</div>
					</div>
				</div>
				<div class="threeBox">
					<div class="titleBox"> 首批联合协会</div>
					<div class="topLogo">
						<img src="../assets/imgs/logos/1.png">
						<div>中国人才交流协会</div>
					</div>
					<div class="logobox">
						<div v-for="(item,i) in threeData" :key="i" class="logoItem">
							<img :src="item.logo">
							<div class="text">{{item.name}}</div>
						</div>
					</div>
				</div> -->
			</div>
		</div>
		<Footer/>
	</div>
</template>
<script>
import NavMenu from '@/components/navMenu.vue'
import Footer from '@/components/footer.vue'
export default {
	components: {
		NavMenu,
		Footer,
	},
	data() {
		return {
			img1: require("@/assets/imgs/lead/img1.png"),
			seconedData: [
				{ text: '开展工信部中小企业经营管理领军人才“促进大中小企业融通创新”专题培训——人力资源服务赋能方向高级研修班，培养一批行业领军人才，打造一批行业领军企业。' },
				{ text: '开展人力资源服务业高管能力提升课程，聚焦行业高管实际需求，培养中高级管理人才。' },
				{ text: '开展国内（外）游学活动，开阔视野，借鉴经验，加强国际交流合作。' },
				{ text: '开展人才测评师培训项目，推广人才测评技术，培养人才测评队伍，促进人才测评业务发展。' },
				{ text: '开展薪税师培训项目，推广薪税服务技术，培养薪税服务专业人才。' },
				{ text: '开展劳动人事争议调解员培训项目，培养人力资源服务企业劳动人事争议调解员队伍，拓展服务业务范围，促进劳动关系和谐稳定。' },
				{ text: '开展求职实用技术培训项目，帮助求职者提升能力水平，促进其求职。' },
				{ text: '开展人工智能培训项目，普及人工智能知识和技术，推动人力资源服务行业与人工智能等新技术融合。' },
			],
			threeData: [
				{ logo: require("@/assets/imgs/logos/2.png"), name: '北京人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/3.png"), name: '山西省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/4.png"), name: '内蒙古人力资源协会' },
				{ logo: require("@/assets/imgs/logos/5.png"), name: '辽宁省人力资源和社会保障行业协会' },
				{ logo: require("@/assets/imgs/logos/6.png"), name: '上海人才服务行业协会' },
				{ logo: require("@/assets/imgs/logos/7.png"), name: '浙江省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/8.png"), name: '安徽省人力资源服务协会' },
				{ logo: require("@/assets/imgs/logos/9.png"), name: '福建省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/10.png"), name: '江西省人力资源发展协会' },
				{ logo: require("@/assets/imgs/logos/11.png"), name: '河南省人才交流协会' },
				{ logo: require("@/assets/imgs/logos/12.png"), name: '广东省人才交流协会' },
				{ logo: require("@/assets/imgs/logos/13.png"), name: '重庆市人才研究和人力资源服务协会' },
				{ logo: require("@/assets/imgs/logos/14.png"), name: '陕西省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/15.png"), name: '青海省人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/16.png"), name: '宁波市人力资源服务行业协会' },
				{ logo: require("@/assets/imgs/logos/17.png"), name: '西安市人力资源服务行业协会' },
			]
		}
	},
	methods: {},
	filters: {
		timer: (value) => {
			return value.substring(0, 10);
		}
	},
}
</script>
<style lang="less" scoped>
.jointActivitywarp {
	width: 100%;
	margin: 0 auto;
	.containerBox {
		min-height: 600px;
		background: linear-gradient(180deg, #1136a8 0%, #1f67cc 51%, #1136a7 100%);
		background-image: url('../assets/imgs/train/bg3.jpg');
		background-size: 100% 100%;
		padding: 46px 0 32px 0;
		box-sizing: border-box;
		.content_warp {
			width: 1160px;
			margin: 0 auto;
			color: #fff;
			.titleBox {
				text-align: center;
				font-size: 24px;
				margin-bottom: 20px;
				font-family: Microsoft YaHei, Microsoft YaHei;
				font-weight: bold;
			}
			.p {
				font-size: 16px;
				text-indent: 32px;
				line-height: 32px;
			}
			.seconedBox {
				margin: 30px 0;
				.titleBox{
					font-size: 20px;
				}
				.databox {
					display: flex;
					flex-wrap: wrap;
					margin-top: 36px;
					.Itembox {
						width: 278px;
						height: 229px;
						background: rgba(204, 221, 255, 0.5);
						box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
						border-radius: 8px 8px 8px 8px;
						margin: 0 16px 16px 0;
						padding: 18px 16px 24px 16px;
						box-sizing: border-box;
						&:nth-child(4n) {
							margin-right: 0;
						}
						display: flex;
						flex-direction: column;
						text-align: center;
						.num {
							font-size: 18px;
							font-weight: bold;
							position: relative;
							margin-bottom: 16px;
							&::before {
								content: '';
								position: absolute;
								width: 22px;
								height: 0px;
								border: 1px solid #fff;
								opacity: 1;
								background: #fff;
								left: 50%;
								transform: translateX(-50%);
								top: 24px;
							}
						}
						.text {
							font-size: 16px;
							line-height: 30px;
							text-align: left;
						}
					}
				}
			}
			.threeBox {
				.titleBox{
					font-size: 20px;
				}
				margin: 30px 0;
				.topLogo {
					display: flex;
					flex-direction: row;
					align-items: center;
					align-content: center;
					justify-content: center;
					width: 278px;
					margin: 32px auto 16px auto;
					background: rgba(204, 221, 255, 0.5);
					box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
					border-radius: 8px 8px 8px 8px;
					padding: 12px 0 12px 0px;
					box-sizing: border-box;
					height: 70px;
					img {
						margin: 0 10px;
					}
					div {
						font-size: 15px;
						line-height: 24px;
					}
				}
				.logobox {
					display: flex;
					flex-wrap: wrap;
					margin-top: 36px;
					.logoItem {
						width: 278px;
						height: 70px;
						background: rgba(204, 221, 255, 0.5);
						box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
						border-radius: 8px 8px 8px 8px;
						margin: 0 16px 16px 0;
						padding: 12px 9px 12px 0;
						box-sizing: border-box;
						&:nth-child(4n) {
							margin-right: 0;
						}
						display: flex;
						flex-direction: row;
						align-items: center;
						align-content: center;
						img {
							margin: 0 9px;
						}
						.text {
							font-size: 15px;
							line-height: 24px;
							text-align: left;
						}
					}
				}
			}
		}
	}
}
</style>


